import React, { useState } from "react";
import {
  Box,
  TextField,
  Typography,
  Button,
  Paper,

  CssBaseline,
} from "@mui/material";
import { layoutCSS } from "../component/common/commonStyle";
import Grid from "@mui/material/Grid2"
const UnicodeFinder = () => {
  const [inputContent, setInputContent] = useState("");
  const [unicodeData, setUnicodeData] = useState("");
  const [plainContent, setPlainContent] = useState("");
  // const handleFindUnicode = () => {
  //   const unicodeChars = [];
  //   const plainChars = [];

  //   for (const char of inputContent) {
  //     const code = char.charCodeAt(0);
  //     if (code > 127) {
  //       // Unicode character
  //       unicodeChars.push(`\\u${code.toString(16).padStart(4, "0")}`);
  //     } else {
  //       // ASCII character
  //       plainChars.push(char);
  //     }
  //   }

  //   setUnicodeData(unicodeChars.join(" "));
  //   setPlainContent(plainChars.join(""));
  // };

  const handleFindUnicode = () => {
    const unicodeChars = [];
    const plainChars = [];

    for (const char of inputContent) {
      const code = char.charCodeAt(0);
      if (code > 127) {
        // Unicode character
        unicodeChars.push(char);
      } else {
        // ASCII character
        plainChars.push(char);
      }
    }

    setUnicodeData(unicodeChars.join("")); // Now directly showing characters
    setPlainContent(plainChars.join(""));
  };
  const inputSx = {
    borderRadius: "0.5rem",
    minWidth: 140,
    "& .MuiOutlinedInput-root": {
      background: "rgba(255,255,255,0.7)",
      "& fieldset": { borderColor: "#E2E8F0" },
      "&:hover fieldset": { borderColor: "#94A3B8" },
    },
    "& .MuiInputLabel-root": { color: "#475569" },
    "& .Mui-disabled": {
      "& .MuiOutlinedInput-input": {
        color: "#334155 !important",
        WebkitTextFillColor: "#334155 !important",
      },
      "& .MuiOutlinedInput-notchedOutline": { borderColor: "#CBD5E1" },
    },
  };

  return (
    <Box
      sx={{
        // minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        // p: 2, // for some padding on smaller screens
      }}
    >
      <Box sx={{ maxWidth: 600, width: "100%", ...layoutCSS }}>
        <Typography variant="h6" gutterBottom sx={{ fontSize: "0.9rem", fontWeight: 'bold' }}>
          Unicode Finder
        </Typography>

        <Grid container spacing={2} direction="column">
          {/* Input Content */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              multiline
              rows={4}
              variant="outlined"
              label="Enter Content"
              placeholder="Enter Content"
              value={inputContent}
              onChange={(e) => setInputContent(e.target.value)}
              sx={inputSx}
              slotProps={{ textField: { size: "small" } }}
            />
          </Grid>

          {/* Button */}
          <Grid item xs={12}>
            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleFindUnicode}
                sx={{ textTransform: "none", fontSize: "0.75rem" }}
              >
                Find Unicode Data
              </Button>
            </Box>
          </Grid>

          {/* Unicode Data Output */}
          <Grid item xs={12}>
            <Typography variant="subtitle1" sx={{ mb: 1, fontSize: "0.75rem" }}>
              Unicode Data:
            </Typography>
            <TextField
              fullWidth
              multiline
              rows={4}
              variant="outlined"
              value={unicodeData}
              sx={inputSx}
              slotProps={{ textField: { size: "small" } }}
              placeholder="Unicode Data"
            />
          </Grid>

          {/* Plain Content Output */}
          <Grid item xs={12}>
            <Typography variant="subtitle1" sx={{ mb: 1, fontSize: "0.75rem" }}>
              Plain Content:
            </Typography>
            <TextField
              fullWidth
              multiline
              rows={4}
              value={plainContent}
              sx={inputSx}
              slotProps={{ textField: { size: "small" } }}
              placeholder="Plain Content"
            />
          </Grid>
        </Grid>
      </Box>
    </Box>

  );
};

export default UnicodeFinder;